module.exports = __webpack_public_path__ + "static/img/company2.d5815f4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company2.png
// module id = DmiK
// module chunks = 8